const KEY_LOGIN_USER = 'login_user';

export const getLoginUser = () => {
  let userStr = window.localStorage.getItem(KEY_LOGIN_USER);
  return userStr ? JSON.parse(userStr) : null;
}

export const setLoginUser = (user) => {
  window.localStorage.setItem(KEY_LOGIN_USER, JSON.stringify(user));
}
